import { render, staticRenderFns } from "./DeviceBindblesn.vue?vue&type=template&id=2f01c2dd&scoped=true&"
import script from "./DeviceBindblesn.vue?vue&type=script&lang=js&"
export * from "./DeviceBindblesn.vue?vue&type=script&lang=js&"
import style0 from "./DeviceBindblesn.vue?vue&type=style&index=0&id=2f01c2dd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f01c2dd",
  null
  
)

export default component.exports